export function BouqsPromo() {
   return (
      <div
         className="flex justify-center"
         style={{ width: '100vw', height: '100vh', zIndex: 99999999, position: 'absolute', top: 0, left: 0 }}>
         <iframe
            src="/assets/bouqs-promo.html"
            style={{ width: '100%', height: '100%' }}></iframe>
      </div>
   );
}
